// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const getMarketStatusDummyData = () => {
    return {
        body: {
            Data: [
                {
                    Exch: "N",
                    ExchDescription: "Nse Cash",
                    ExchType: "C",
                    MarketStatus: "Open",
                },
                {
                    Exch: "N",
                    ExchDescription: "Nse Derivative",
                    ExchType: "D",
                    MarketStatus: "Open",
                },
                {
                    Exch: "B",
                    ExchDescription: "Bse Cash",
                    ExchType: "C",
                    MarketStatus: "Open",
                },
                {
                    Exch: "N",
                    ExchDescription: "Nse Currency",
                    ExchType: "U",
                    MarketStatus: "Open",
                },
                {
                    Exch: "B",
                    ExchDescription: "Bse Derivative",
                    ExchType: "D",
                    MarketStatus: "Open",
                },
                {
                    Exch: "M",
                    ExchDescription: "MCX",
                    ExchType: "D",
                    MarketStatus: "Open",
                },
            ],
            Message: "Success",
            Status: 0,
        },
        head: {
            responseCode: "5PMarketStatus",
            status: "0",
            statusDescription: "Success",
        },
    };
};
